import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const RefundReservationSuccessTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const config = domain.get('config')
  const urlStaticsImages = config.get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/process-completed-success.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-RefundReservationSuccessModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t('VEHICLE_RESERVATION.MODAL_REFUND_RESERVATION_SUCCESS.NOTIFICATION')}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('VEHICLE_RESERVATION.MODAL_PAYMENT_SUCCESS.CTA')
                }
              },
              children: (
                <div className="mt-RefundReservationSuccessModal-modalChildren">
                  <div className="mt-ReservationPaymentSuccessModal-description">
                    {i18n.t('VEHICLE_RESERVATION.MODAL_REFUND_RESERVATION_SUCCESS.DESCRIPTION')}
                  </div>
                  <div className="mt-RefundReservationSuccessModal-modalChildren-contentImageWrapper">
                    <AtomImage
                      alt={i18n.t('VEHICLE_RESERVATION.MODAL_REFUND_RESERVATION_SUCCESS.TITLE')}
                      src={imageUrl}
                    />
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_RESERVATION.MODAL_REFUND_RESERVATION_SUCCESS.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
